import { WebsocketService, WebsocketStateType } from '../services/websocket.service';

import { Player } from './player';
import { SceneManager } from './scene-manager';

export default class Movement {
  public static readonly MOVE_UP = 1;
  public static readonly MOVE_DOWN = 2;
  public static readonly MOVE_LEFT = 4;
  public static readonly MOVE_RIGHT = 8;

  private static instance: Movement;

  private websocketService?: WebsocketService;
  private firstMovementDone?: boolean;
  private player: Player | undefined;

  public constructor(private sceneManager: SceneManager) {}

  public static getInstance(sceneManager: SceneManager): Movement {
    if (!Movement.instance) {
      Movement.instance = new Movement(sceneManager);
    }
    return Movement.instance;
  }

  public moveBy(direction: number, moveWithMouse?: boolean): void {
    if (this.websocketService?.state !== WebsocketStateType.CONNECTED) {
      return;
    }
    this.websocketService.sendRaw('md:' + direction);
  }

  public moveTo({ moveWithMouse, x, y }: { x?: number; y?: number; moveWithMouse?: boolean }): void {
    const location: string = x && y ? `${Math.round(x)},${Math.round(y)}` : '';
    if (this.websocketService?.state !== WebsocketStateType.CONNECTED) {
      return;
    }
    this.player = this.sceneManager.getPlayer();
    if (this.player && this.sceneManager.enableCenterViewport && (x || y)) {
      this.player.setPlayerNotMovingTimeout();
    }

    this.websocketService.sendRaw('mt:' + location);
  }

  public init(websocketService: WebsocketService): void {
    this.firstMovementDone = undefined;
    this.websocketService = websocketService;
  }
}
